/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Progress_Aria_LabelInputs */

const en_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio rendering progress`)
};

const fr_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression du rendu audio`)
};

const de_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt der Audiowiedergabe`)
};

const it_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso del rendering audio`)
};

const ru_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход обработки звука`)
};

const es_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de la representación de audio`)
};

const zh_cn2_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频渲染进度`)
};

const ja_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオレンダリングの進行状況`)
};

const hi_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रेंडरिंग की प्रगति`)
};

const pt_pt2_render_audio_progress_aria_label = /** @type {(inputs: Render_Audio_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso da renderização de áudio`)
};

/**
* | output |
* | --- |
* | "Audio rendering progress" |
*
* @param {Render_Audio_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_progress_aria_label = /** @type {((inputs?: Render_Audio_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_progress_aria_label(inputs)
	if (locale === "de") return de_render_audio_progress_aria_label(inputs)
	if (locale === "it") return it_render_audio_progress_aria_label(inputs)
	if (locale === "ru") return ru_render_audio_progress_aria_label(inputs)
	if (locale === "es") return es_render_audio_progress_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_progress_aria_label(inputs)
	if (locale === "ja") return ja_render_audio_progress_aria_label(inputs)
	if (locale === "hi") return hi_render_audio_progress_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_progress_aria_label(inputs)
	return en_render_audio_progress_aria_label(inputs)
});